import { BookingApplicationCheckoutState, BookingCheckoutState } from '@shared/types';
import { FunctionComponent } from 'react';
import { IconSummary } from '../../IconSummary';
import { UserLightIcon, UserGroupLightIcon } from '../../../../Icons';
import { PublicBlendedCourse, PublicClassCourse } from '@cademy-package/sdk-component-types';

export type SpacesSummaryProps = {
    course: PublicClassCourse | PublicBlendedCourse;
    checkoutState: BookingCheckoutState | BookingApplicationCheckoutState;
};

export const SpacesSummary: FunctionComponent<SpacesSummaryProps> = ({ course, checkoutState }) => {
    if (checkoutState.stepState.price.status !== 'complete') {
        return null;
    }
    if (checkoutState.stepState.price.state.spacesRequested === 1) {
        return <IconSummary Icon={UserLightIcon}>1 space</IconSummary>;
    }
    return (
        <IconSummary Icon={UserGroupLightIcon}>
            {checkoutState.stepState.price.state.spacesRequested} spaces
        </IconSummary>
    );
};
